import styles from './header.module.css';
import Hamburger from './hamburger/hamburger';
import Logo from './logo/logo';

const Header = () => {
    return (
        <header className={styles.headerContainer}>
            <div className={styles.headInfo}>
                <Logo />
                <Hamburger />
            </div>
            <div className={styles.headerBackground} ></div>
        </header>
    );
};

export default Header;
